import { useSelector } from 'react-redux';

import { isMasterAdmin } from 'shared/consts/consts';

import { isResellerAdminSelector } from 'store/App/User/selectors';
import { RootState } from 'store/rootReducer';

import ResetAccountPasswordModal from './ResetAccountPasswordModal';

export enum PASSWORD_STATUS {
	ACTIVE = 'ACTIVE',
	EXPIRED = 'PASSWORD_EXPIRED',
}

function ResetAccountPassword() {
	const isPasswordExpired = useSelector(
		(state: RootState) => state.User.botAdmin.data.status === PASSWORD_STATUS.EXPIRED
	);
	const isResellerAdmin = useSelector(isResellerAdminSelector);

	return isPasswordExpired && !isMasterAdmin && !isResellerAdmin ? <ResetAccountPasswordModal /> : null;
}

export default ResetAccountPassword;
